import { HttpMethod, initFetch } from "../../../../shared/utils";
let hostname = window.location.hostname;
let API_HOST_URI = "https://topup-api.superapp.my";
export let COOKIES_NAME = "topupbar.sid";
export let APP_COOKIES = "topupbar.app";
switch (true) {
    case /^local/gi.test(hostname):
        API_HOST_URI = "http://local-topup-api.topupbar.com:3500";
        COOKIES_NAME = "topupbar.sb.sid";
        APP_COOKIES = "topupbar.sb.app";
        break;
    case /^sb\-/gi.test(hostname):
        API_HOST_URI = "https://sb-topup-api.superapp.my";
        COOKIES_NAME = "topupbar.sb.sid";
        APP_COOKIES = "topupbar.sb.app";
        break;
}
const fetchCall = initFetch(API_HOST_URI);
export const getOptions = () => {
    return fetchCall(HttpMethod.GET, `/v1/prepaid/products`).then(({ items }) => items);
};
export const createOrder = (msisdn, id) => {
    return fetchCall(HttpMethod.POST, `/v1/prepaid/order`, {
        body: {
            id,
            msisdn,
        },
    }).then(({ item }) => item);
};
export const updateOrder = (orderId, msisdn, id, voucherCode) => {
    return fetchCall(HttpMethod.PATCH, `/v1/prepaid/order/${orderId}`, {
        body: {
            id,
            msisdn,
            voucherCode,
        },
    }).then(({ item }) => item);
};
export const proceedPayment = (orderId) => {
    return fetchCall(HttpMethod.POST, `/v1/prepaid/payment`, {
        body: {
            orderId,
        },
    }).then(({ item }) => item);
};
export const getOrder = (id) => {
    return fetchCall(HttpMethod.GET, `/v1/prepaid/order/${id}`).then(({ item }) => item);
};
export const getOrders = ({ cursor, }) => {
    return fetchCall(HttpMethod.GET, `/v1/prepaid/orders?cursor=${cursor}`);
};
export const loginGoogle = () => {
    return fetchCall(HttpMethod.GET, `/v1/auth/prepaid/google`).then(({ item }) => item);
};
export const loginFacebook = () => {
    return fetchCall(HttpMethod.GET, `/v1/auth/prepaid/facebook`).then(({ item }) => item);
};
